import {useNavigate} from "react-router-dom";
import {useSetUserSession} from "../../../state/user-session";
import {useEffect} from "react";
import {queryStringToObject} from "../../../utils/collection-util";
import {callBackLogin} from "../domain/callback-login";

export function CallbackNaverLogin() {
    const navigate = useNavigate();
    const [login,] = useSetUserSession()

    useEffect(() => {
        const params = window.location.href.includes('?') ? queryStringToObject(window.location.href.split('?')[1].split('#')[0]) : {}//regex 찾아보기 귀찮아서 걍 구현;
        const params2 = queryStringToObject(window.location.href.split('#')[1]);
        const token = params2.access_token;

        params.oauthProvider = "NAVER"
        params.oauthAccessToken = token

        callBackLogin(navigate, login, params)
    }, [])
}